import { Component } from "@angular/core";

@Component({
    selector: "app-empty-layout",
    template: "<router-outlet></router-outlet>",
    styles: [":host { display: block; height: 100vh; width: 100vw; background: #f5f5f5; }"],
    standalone: false
})
export class EmptyLayoutComponent {}
